<template>
  <div class="transport-page" :class="{ 'is-en': isEn }">
    <site-header />
    <section class="page-banner" :style="{ backgroundImage: 'url(' + banner + ')' }"></section>
    <section class="transport-body">
      <div class="stage" :class="'mode-' + currentKey">
        <a
          v-for="item in modes"
          :key="item.key"
          class="tab"
          :class="{ active: item.key === currentKey }"
          href="javascript:void(0)"
          @click="selectMode(item.key)"
        >{{ item.name }}</a>
        <h1>{{ current.name }}</h1>
        <div class="desc">
          <p v-for="(para, index) in current.paragraphs" :key="index">{{ para }}</p>
        </div>
        <img class="photo left" :src="fileUrl(current.left)" :alt="current.name">
        <img class="photo right" :src="fileUrl(current.right)" :alt="current.name">
      </div>
    </section>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { fileUrl } from '@/utils/fileUrl'
import { getCopy, langPath } from '@/locale'

export default {
  name: 'TransportPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      banner: fileUrl('transport/transitpostBanner.png')
    }
  },
  computed: {
    /** 是否英文站 */
    isEn() {
      return this.$route.meta && this.$route.meta.lang === 'en'
    },
    /** 按路由语言取运输文案 */
    copy() {
      return getCopy(this.isEn ? 'en' : 'zh')
    },
    /** 四种运输方式（含文案与配图） */
    modes() {
      const t = this.copy.transport
      return [
        {
          key: 'water',
          name: t.waterName,
          paragraphs: [t.waterP1],
          left: 'transport/水上运输-2.jpg',
          right: 'transport/水上运输-1.jpg'
        },
        {
          key: 'road',
          name: t.roadName,
          paragraphs: [t.roadP1],
          left: 'transport/公路运输-2.jpg',
          right: 'transport/公路运输-1.jpg'
        },
        {
          key: 'rail',
          name: t.railName,
          paragraphs: [t.railP1],
          left: 'transport/铁路运输-1.jpg',
          right: 'transport/铁路运输-2.jpg'
        },
        {
          key: 'air',
          name: t.airName,
          paragraphs: [t.airP1, t.airP2],
          left: 'transport/航空运输-2.jpg',
          right: 'transport/航空运输-1.jpg'
        }
      ]
    },
    /** 当前选中的运输方式，地址没带参数时默认水上运输 */
    currentKey() {
      const type = this.$route.query.type
      const found = this.modes.some(function (item) {
        return item.key === type
      })
      return found ? type : 'water'
    },
    current() {
      const key = this.currentKey
      return this.modes.filter(function (item) {
        return item.key === key
      })[0]
    }
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    },
    /** 切换运输方式，页头和页脚不动，只换中间正文 */
    selectMode(key) {
      const lang = this.$route.meta && this.$route.meta.lang === 'en' ? 'en' : 'zh'
      this.$router.replace({ path: langPath(lang, '/transport'), query: { type: key } })
    }
  }
}
</script>

<style scoped>
.transport-page {
  background: #fff;
  color: #333;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.page-banner {
  height: 500px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}
.transport-body {
  min-height: 595px;
}
.stage {
  position: relative;
  max-width: 1200px;
  min-height: 595px;
  margin: 0 auto;
}
.tab {
  position: absolute;
  left: 0;
  width: 16.666667%;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  background: #f2f2f2;
  color: #333;
  font-size: 18px;
  text-align: center;
  text-decoration: none;
}
.tab:nth-child(1) { top: 48px; width: 200px; }
.tab:nth-child(2) { top: 98px; }
.tab:nth-child(3) { top: 148px; }
.tab:nth-child(4) { top: 198px; }
.tab.active {
  background: #3db7ef;
  color: #fff;
}
.stage h1 {
  position: absolute;
  top: 48px;
  left: 25%;
  width: 35.92233%;
  margin: 0;
  font-size: 26px;
  font-weight: normal;
  line-height: 50px;
  color: #333;
}
.desc {
  position: absolute;
  top: 111px;
  left: 25%;
  width: 75%;
  font-size: 16px;
  line-height: 30px;
  color: #808080;
  text-align: justify;
}
.desc p {
  margin: 0;
}
.desc p + p {
  margin-top: 30px;
}
.photo {
  position: absolute;
  top: 332px;
  width: 29.166667%;
  height: auto;
}
.photo.left { left: 30.416667%; }
.photo.right { left: 64.916667%; }
.mode-water { min-height: 630px; }
.mode-road { min-height: 510px; }
.mode-rail { min-height: 552px; }
.mode-air { min-height: 595px; }
.mode-water .photo { top: 334px; }
.mode-water .photo.left { left: 29.5%; }
.mode-water .photo.right { left: 64%; }
.mode-road .photo { top: 243px; }
.mode-rail .photo { top: 271px; }
.mode-air .photo { top: 332px; }
/*
 * 英文站：中英文分路由，这里用文档流排正文+配图，避免长英文和绝对定位图片打架。
 * 中文站仍用上方官网同款绝对定位，不必复制整页组件。
 */
.transport-page.is-en .stage {
  min-height: auto;
  padding: 48px 0 48px 220px;
  box-sizing: border-box;
  overflow: hidden;
}
.transport-page.is-en .tab {
  font-size: 15px;
  width: 200px;
  white-space: nowrap;
}
.transport-page.is-en .tab:nth-child(1),
.transport-page.is-en .tab:nth-child(2),
.transport-page.is-en .tab:nth-child(3),
.transport-page.is-en .tab:nth-child(4) {
  width: 200px;
}
.transport-page.is-en .stage h1 {
  position: static;
  width: auto;
  margin: 0 0 18px;
  line-height: 1.3;
  white-space: normal;
}
.transport-page.is-en .desc {
  position: static;
  width: 100%;
  margin: 0 0 28px;
}
.transport-page.is-en .photo {
  position: static;
  float: left;
  top: auto;
  left: auto;
  width: 48%;
  margin: 0;
}
.transport-page.is-en .photo.left { margin-right: 4%; }
.transport-page.is-en .photo.right { margin-right: 0; }
.transport-page.is-en .mode-water,
.transport-page.is-en .mode-road,
.transport-page.is-en .mode-rail,
.transport-page.is-en .mode-air {
  min-height: auto;
}
.transport-page.is-en .mode-water .photo,
.transport-page.is-en .mode-road .photo,
.transport-page.is-en .mode-rail .photo,
.transport-page.is-en .mode-air .photo {
  top: auto;
  left: auto;
}
@media (min-width: 641px) and (max-width: 1200px) {
  .page-banner { height: 350px; }
  .tab { font-size: 16px; }
  .tab:nth-child(1) { left: 2.777041%; width: 180px; }
  .tab:nth-child(2),
  .tab:nth-child(3),
  .tab:nth-child(4) { left: 2.777041%; width: 19.088017%; }
  .stage h1 { left: 27.492047%; width: 34.464475%; font-size: 24px; }
  .desc { left: 27.492047%; top: 121px; width: 70%; font-size: 14px; }
  .photo { width: 31.4%; height: auto; }
  .mode-water,
  .mode-road { min-height: 520px; }
  .mode-rail { min-height: 540px; }
  .mode-air { min-height: 640px; }
  .mode-water .photo,
  .mode-road .photo { top: 248px; }
  .mode-water .photo.left,
  .mode-road .photo.left { left: 30.567338%; }
  .mode-water .photo.right,
  .mode-road .photo.right { left: 65.54878%; }
  .mode-rail .photo { top: 271px; }
  .mode-rail .photo.left { left: 28.189621%; }
  .mode-air .photo { top: 370px; }
  .mode-air .photo.left { left: 29.029692%; }
  .mode-air .photo.right { left: 64.488335%; }
  .transport-page.is-en .stage { padding-left: 200px; }
  .transport-page.is-en .photo { float: left; width: 48%; }
}
@media (max-width: 640px) {
  .page-banner { height: 250px; }
  .mode-water,
  .mode-road { min-height: 760px; }
  .mode-rail { min-height: 830px; }
  .mode-air { min-height: 920px; }
  .tab {
    top: 13px;
    width: 23%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
  .tab:nth-child(1) { left: 0.998623%; }
  .tab:nth-child(2) { left: 25.998623%; }
  .tab:nth-child(3) { left: 50.998623%; }
  .tab:nth-child(4) { left: 76.033058%; }
  .stage h1 {
    top: 73px;
    left: 8.126722%;
    width: 270px;
    font-size: 18px;
    line-height: 30px;
  }
  .desc {
    top: 120px;
    left: 1.101928%;
    width: 98%;
    font-size: 12px;
  }
  .desc p { text-indent: 2em; }
  .photo {
    left: 1.5%;
    width: 97%;
    height: 214px;
    object-fit: cover;
    object-position: center top;
  }
  .mode-water .photo.left,
  .mode-road .photo.left { top: 287px; }
  .mode-water .photo.right,
  .mode-road .photo.right { top: 513px; }
  .mode-rail .photo.left { top: 349px; }
  .mode-rail .photo.right { top: 575px; }
  .mode-air .photo.left { top: 450px; }
  .mode-air .photo.right { top: 664px; }
  .transport-page.is-en .stage {
    padding: 16px 12px 40px;
  }
  .transport-page.is-en .tab {
    position: relative;
    top: auto !important;
    left: auto !important;
    display: inline-block;
    width: 48% !important;
    margin: 0 1% 8px;
  }
  .transport-page.is-en .photo {
    float: none;
    display: block;
    width: 100%;
    margin: 0 0 12px;
  }
}
</style>
